/*
The shipping component manages the presentation of the shipping messaging on the cart drawer.
 */

import Component from "./../../component";

export const CartDrawerShippingConfig = {
  signature: 'CartDrawerShipping',
  baseHtmlClass: 'go-cart__drawer__shipping',
  selector: '.go-cart__drawer__shipping',

  initedHtmlClassModifier: 'inited',
  hasFreeShippingHtmlClassModifier: 'free_shipping',

  messageSelector: '.go-cart__drawer__shipping__message',
  defaultFreeShippingMessage: 'Free Shipping',

  freeShippingThreshold: 13000,
};

export class CartDrawerShipping extends Component {

  constructor(id_or_element, goCart) {
    super({
      element: id_or_element,
      config: CartDrawerShippingConfig
    });

    this.goCart = goCart;

    this.messageElement = this.element.querySelector(this.config.messageSelector);
    this.initialMessageContent = (!!this.messageElement) ? this.messageElement.innerHTML : this.config.defaultFreeShippingMessage;

    this.cartSubtotal = null;
    this.moneyFormat = null;

    this.inited = true;
    this.render();
  }

  render() {
    this.conditionallySetHtmlClassState(this.inited, CartDrawerShippingConfig.initedHtmlClassModifier);
    this.conditionallySetHtmlClassState(this.hasFreeShipping(), CartDrawerShippingConfig.hasFreeShippingHtmlClassModifier);
    if (this.messageElement) this.renderMessage();
  }

  hasFreeShipping() {
    if (this.cartSubtotal == null) return false;
    return (this.cartSubtotal >= CartDrawerShippingConfig.freeShippingThreshold);
  }


  renderMessage() {
    if (this.hasFreeShipping()) {
      this.messageElement.innerHTML = this.initialMessageContent;
    } else {
      const diff = (CartDrawerShippingConfig.freeShippingThreshold - this.cartSubtotal)/100;
      const remaining = Number((diff).toFixed(0));
      this.messageElement.innerHTML = `$${ remaining } away from free shipping*`;
    }
  }

}
